import React from "react";
import { Trans } from 'react-i18next';

import {
    Frame, Blockquote,Link as Lien
} from "arwes";
import {useNavigate} from "react-router-dom";
const Categories = () => {




    return(
              <div>
                  <div>
                      <Blockquote >Categories</Blockquote>
                  </div>
                  <div style={{ display: 'inline-block', padding: '20px' }} className="col-xs-12 col-md-12 col-lg-12">
                      <div className="row"  >


                        <Frame
                            style={{ padding: '20px' }}
                        animate={true}
                        level={3}
                        corners={4}
                        layer='primary'
                        >
                            <div  className="text-center" style={{ padding: '20px ', fontSize: '32px'}}>
                                <Lien  style={{ textDecoration:'none' }} href=""><Trans>Time travel</Trans></Lien>
                            </div>
                        </Frame>

                        <Frame
                            style={{  padding: '20px' }}
                            animate={true}
                            level={3}
                            corners={4}
                            layer='primary'
                        >
                            <div className="text-center" style={{ padding: '20px 40px', fontSize: '32px'}}>
                                <Lien style={{ textDecoration:'none' }} href=""><Trans>Parallels universe</Trans></Lien>
                            </div>
                        </Frame>



                        <Frame
                            style={{  padding: '20px' }}
                            animate={true}
                            level={3}
                            corners={4}
                            layer='primary'
                        >
                            <div className="text-center" style={{ padding: '20px 40px', fontSize: '32px'}}>
                                <Lien style={{ textDecoration:'none' }} href=""><Trans>Extraterrestrial life</Trans></Lien>
                            </div>
                        </Frame>

                </div>
                      </div>

                      <div style={{ display: 'inline-block' }} className="col-xs-12 col-md-12 col-lg-12 text-center" >
                          <div className="row">

                    <Frame
                        style={{  padding: '20px' }}
                        animate={true}
                        level={3}
                        corners={4}
                        layer='primary'
                    >
                        <div style={{ padding: '20px 40px', fontSize: '32px'}}>
                            <Lien style={{ textDecoration:'none' }} href=""><Trans>Space exploration</Trans></Lien>
                        </div>
                    </Frame>


                    <Frame
                        style={{  padding: '20px' }}
                        animate={true}
                        level={3}
                        corners={4}
                        layer='primary'
                    >
                        <div className="text-center" style={{ padding: '20px 40px', fontSize: '32px'}}>
                            <Lien style={{ textDecoration:'none' }} href="/articifial-intelligence"> <Trans>Artificial Intelligence</Trans></Lien>
                        </div>
                    </Frame>


                    <Frame
                        style={{  padding: '20px' }}
                        animate={true}
                        level={3}
                        corners={4}
                        layer='primary'
                    >
                        <div className="text-center" style={{ padding: '20px 40px', fontSize: '32px'}}>
                            <Lien style={{ textDecoration:'none' }} href=""><Trans>Virtual reality</Trans></Lien>
                        </div>
                    </Frame>

                             </div>
                      </div>

              </div>
    )
}
export default Categories
